import store from '../store/index'

export function menuPermission(permission) {
    let myPermissions = store.state.menuPermission;
    // console.log(permission,'permission')
    // console.log(myPermissions,']]]')
    // console.log(myPermissions.indexOf(permission) > -1,'3333')


    return myPermissions.indexOf(permission) > -1;
}